"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var SiteMenu_1;
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMenu = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const routes_1 = require("@front/routes");
const route_types_1 = require("@front/types/route.types");
const events_1 = require("@front/event/events");
const browser_router_1 = require("@rws-framework/browser-router");
const component_1 = require("@front/layouts/default-layout/component");
const backendImport_1 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<div
    class="sidebar${x => [0].includes(x.menuState) ? ' main-hidden' : ''}${x => [0, 1].includes(x.menuState) ? ' sub-hidden' : ''}">
    <div class="main-menu">
        <div class="scroll">
            <div class="scrollbar-container ps ps--active-y">
                <ul class="list-unstyled nav flex-column">
                    ${T.repeat(x => x.links, T.html `
                   <li
                        class="nav-item${(x, c) => { var _a, _b; return x.path === ((_a = c.parent.parentPosition) === null || _a === void 0 ? void 0 : _a.path) || x.path === ((_b = c.parent.currentPosition) === null || _b === void 0 ? void 0 : _b.forceActive) ? ' active' : ''; }}">
                        <a @click="${(x, c) => c.parent.handleClick(c.event, x)}" href="${x => x.path}">
                            ${T.when(x => x.icon, T.html `<i class="iconsminds-${x => x.icon}"></i>`)}${x => x.name.t()}
                        </a>
                    </li>
                    `)}
                </ul>
            </div>
        </div>
    </div>

    ${(0, fast_element_1.when)(x => x.submenu && x.submenu.length, (0, fast_element_1.html) `
    <div class="sub-menu">
        <div class="scroll">
            <div class="scrollbar-container ps">
                <ul class="nav d-block">
                    ${(0, fast_element_1.repeat)(x => x.submenu, (0, fast_element_1.html) `
                        ${(0, fast_element_1.when)(x => x.inMenu, (0, fast_element_1.html) `
                            <li
                                class="nav-item${(x, c) => { var _a, _b; return x.path === ((_a = c.parent.currentPosition) === null || _a === void 0 ? void 0 : _a.path) || x.path === ((_b = c.parent.currentPosition) === null || _b === void 0 ? void 0 : _b.forceActive) ? ' active' : ''; }}">
                                <a @click="${(x, c) => c.parent.handleClick(c.event, x)}" href="${x => x.path}">
                                    ${(0, fast_element_1.when)(x => x.icon, (0, fast_element_1.html) `<i class="simple-icon-${x => x.icon}"></i>`)}
                                    ${x => x.name.t()}
                                </a>
                            </li>
                        `)}    
                    `)}
                </ul>
            </div>
        </div>
    </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.sub-menu ul li:after {
  display: none;
}`;
const shadowOptions = { "mode": "open" };
let SiteMenu = SiteMenu_1 = class SiteMenu extends client_1.RWSViewComponent {
    constructor(routingService) {
        super();
        this.routingService = routingService;
        this.parentPosition = null;
        this.currentPosition = null;
        this.currentUrl = null;
        this.menuState = 2; // 0 - closed, 1 - main menu open, 2 - sub menu open
        this.links = [];
        this.submenu = [];
    }
    getLinks() {
        const user = component_1.DefaultLayout.USER;
        const userPolicy = (user === null || user === void 0 ? void 0 : user.acl) || null;
        if (!user) {
            this.links = [];
            return;
        }
        this.links = routes_1.frontRoutes.filter(route => route.inMenu).filter(route => {
            if (user.role === backendImport_1.UserRoles.SUPER_ADMIN) {
                return true;
            }
            // If route has no ACL requirement, show it
            if (!route.acl) {
                return true;
            }
            // If user has no ACL policy, hide ACL-protected routes
            if (!userPolicy) {
                return false;
            }
            // Check ACL permission
            return backendImport_1.ACL.checkACL(route.acl, userPolicy);
        });
    }
    async connectedCallback() {
        super.connectedCallback();
        SiteMenu_1.routingService = this.routingService;
        let compareUrl = this.currentUrl;
        let foundPath = this.findPath(compareUrl);
        if (foundPath) {
            this.currentPosition = foundPath;
        }
        this.getLinks();
        this.setParentPosition();
        component_1.DefaultLayout.get().on(events_1.appEvents.login, () => {
            this.getLinks();
            this.setParentPosition();
        });
    }
    findPath(compareUrl) {
        return SiteMenu_1.findPathInRoutes(compareUrl);
    }
    static findPathInRoutes(compareUrl) {
        if (!SiteMenu_1.routingService) {
            return null;
        }
        let foundPath = routes_1.frontRoutes.find((item) => SiteMenu_1.routingService.compareMatchingPath(compareUrl, item.path));
        if (!foundPath) {
            for (const routes of routes_1.frontRoutes) {
                if (routes.children && routes.children.length) {
                    foundPath = routes.children.find((item) => SiteMenu_1.routingService.compareMatchingPath(compareUrl, item.path));
                }
                if (foundPath) {
                    break;
                }
            }
        }
        return foundPath;
    }
    setParentPosition() {
        if (this.currentPosition) {
            this.parentPosition = routes_1.frontRoutes.find((item) => {
                let parentLink = null;
                if (item.children && item.children.length) {
                    for (const sibl of item.children) {
                        if (sibl.path === this.currentPosition.path) {
                            parentLink = item;
                        }
                    }
                }
                return parentLink;
            });
        }
        this.setSubmenu();
    }
    setSubmenu() {
        if (this.parentPosition && this.parentPosition.children && this.parentPosition.children.length) {
            this.submenu = this.parentPosition.children;
        }
        if (this.currentPosition && this.currentPosition.children && this.currentPosition.children.length) {
            this.submenu = this.currentPosition.children;
        }
        this.submenu = this.submenu.filter((item) => {
            if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
                return true;
            }
            if (component_1.DefaultLayout.USER.role !== backendImport_1.UserRoles.SUPER_ADMIN && item.path === '/settings/account-grade/list') {
                return false;
            }
            if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.USER && item.path === '/reports/cost') {
                return false;
            }
            if (component_1.DefaultLayout.USER.role !== backendImport_1.UserRoles.SUPER_ADMIN && item.path === '/dblogs/list') {
                return false;
            }
            // If route has no ACL requirement, show it
            if (!item.acl) {
                return true;
            }
            // If user has no ACL policy, hide ACL-protected routes
            if (!component_1.DefaultLayout.USER.acl) {
                return false;
            }
            // Check ACL permission
            return backendImport_1.ACL.checkACL(item.acl, component_1.DefaultLayout.USER.acl);
        });
        if (!this.submenu.length) {
            this.$emit(events_1.appEvents.setMenuState, { state: 1 });
        }
        else {
            this.$emit(events_1.appEvents.setMenuState, { state: 2 });
        }
    }
    handleClick(event, link) {
        if (event) {
            event.preventDefault();
        }
        this.submenu = [];
        this.currentPosition = link;
        if (!link.children || !link.children.length) {
            this.setParentPosition();
        }
        else {
            this.parentPosition = link;
            this.setSubmenu();
        }
        SiteMenu_1.goto.bind(this)(link.path);
    }
    logout() {
        this.$emit('logout');
    }
    static goto(path) {
        const splitPath = path.split('#');
        const mainPath = splitPath[0];
        const hash = splitPath[1] || '';
        if (!SiteMenu_1.findPathInRoutes(mainPath)) {
            console.error(`No route found for path: ${mainPath}`);
            return;
        }
        this.$emit('routing.url.changed', {
            item: mainPath,
            hash
        });
    }
};
exports.SiteMenu = SiteMenu;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SiteMenu.prototype, "passedFrontRoute", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof route_types_1.IFrontRouteDef !== "undefined" && route_types_1.IFrontRouteDef) === "function" ? _b : Object)
], SiteMenu.prototype, "parentPosition", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof route_types_1.IFrontRouteDef !== "undefined" && route_types_1.IFrontRouteDef) === "function" ? _c : Object)
], SiteMenu.prototype, "currentPosition", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SiteMenu.prototype, "currentUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SiteMenu.prototype, "menuState", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SiteMenu.prototype, "links", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SiteMenu.prototype, "submenu", void 0);
exports.SiteMenu = SiteMenu = SiteMenu_1 = __decorate([
    (0, client_1.RWSView)('site-menu', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(browser_router_1.RoutingService)),
    __metadata("design:paramtypes", [typeof (_a = typeof browser_router_1.RoutingServiceInstance !== "undefined" && browser_router_1.RoutingServiceInstance) === "function" ? _a : Object])
], SiteMenu);
SiteMenu.defineComponent();
